import { FaBook, FaMoneyBillWave, FaFutbol, FaLayerGroup, FaChartBar } from 'react-icons/fa';
import { getLandingLeagueId } from './landingsConfig';
import { COUNTRY_CODES } from './countryCodes';

export const pageHeaders = {
  home: {
    seoKey: 'home',
    title: "Today's Football Predictions & Expert Tips",
    subtitle: 'Upset picks, high-confidence selections, live scores, and accas',
    icon: FaFutbol,
  },
  accumulators: {
    seoKey: 'accumulators',
    title: 'Accumulator Tips Today',
    subtitle: 'Ready-made accas for every matchday, built from our predictions',
    icon: FaLayerGroup,
  },
  guides: {
    seoKey: 'guides',
    title: 'Learn to Bet on Football',
    subtitle: 'Simple guides for beginners: odds, bankroll, and your first bet',
    icon: FaBook,
  },
  bonuses: {
    seoKey: 'bonuses',
    title: 'Bookmaker Bonuses',
    subtitle: 'Welcome offers and promo codes for Africa and Asia. Terms explained simply',
    icon: FaMoneyBillWave,
  },
  results: {
    seoKey: 'statistics',
    title: 'Prediction Results',
    subtitle: 'Last 30 days: settled picks, not promises',
    icon: FaChartBar,
  },
  predictionsByDate: {
    seoKey: 'home',
    title: 'Football Predictions',
    subtitle: 'Picks and match previews for this day',
    icon: FaFutbol,
  },
  bestBettingSites: {
    seoKey: 'bestBettingSites',
    title: 'Best Betting Sites',
    subtitle: 'Compare welcome bonuses, promo codes, and ratings',
    icon: FaMoneyBillWave,
  },
  about: {
    seoKey: 'about',
    variant: 'minimal',
    title: 'About Us',
  },
  privacy: {
    variant: 'minimal',
    title: 'Privacy Policy',
  },
};

/** Strip seoKey before spreading onto PageHeader */
export const toPageHeaderProps = ({ seoKey, ...rest }) => rest;

/** Dynamic bookmaker tag pages */
export const getPredictionsTagsHeader = (displayName) => ({
  title: `${displayName} Predictions for Today`,
  subtitle: `Today's ${displayName} football predictions: previews and correct score angles`,
  icon: FaFutbol,
});

/** MiniLanding entries from landingsConfig */
export const landingToPageHeader = (landing) => ({
  variant: 'config',
  leagueId: getLandingLeagueId(landing),
  icon: typeof landing.icon === 'function' ? landing.icon : undefined,
  title: landing.title,
  subtitle: landing.subtitle,
});

/** Country bonus pages from countryBonusesConfig */
export const countryBonusToPageHeader = (content, countryCode) => ({
  icon: FaMoneyBillWave,
  countryCode,
  title: content.title,
  subtitle: content.subtitle,
});

/** Magnet review hubs from magnetHubs/ */
export const magnetHubToPageHeader = (hub) => ({
  icon: FaMoneyBillWave,
  countryCode: COUNTRY_CODES[hub.id],
  title: hub.header.title,
  subtitle: hub.header.subtitle,
});
